import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonCoreComponent } from '../button-core/button-core.component';

import '@diekeure/dcr-components/dcr-badge.js';
import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-state-layer.js';

@Component({
  standalone: false,
  selector: 'campus-elevated-button, [elevated-button]',
  templateUrl: './elevated-button.component.html',
  styleUrls: ['./elevated-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElevatedButtonComponent extends ButtonCoreComponent {
  @HostBinding('class')
  defaultClasses = [
    ...this.coreClasses,
    'elevated-button',

    'inline-flex',
    'surface-container-low',
    'text-primary',

    'w-fit',
    'elevation-1',

    'corner-full',
    'border',
    'border-transparent',

    'hover:elevation-2',
    'active:elevation-1',

    'disabled:bg-on-surface',
    'disabled:bg-opacity-press',
    'disabled:elevation-0',
    'disabled:on-surface',
    'disabled:border-none',

    'transition-elevation',

    'selected:primary',
  ];

  @HostBinding('attr.data-has-leading-icon')
  @Input()
  leadingIcon: string;

  @HostBinding('attr.data-has-trailing-icon')
  @Input()
  trailingIcon: string;
}
